class ExternalStores extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('mouseenter', this.drop)
    this.addEventListener('mouseleave', this.close)
    this.addEventListener('click', this.click)
  }

  click(e) {
    e.target.classList.toggle('dropdown')
  }

  close(e) {
    setTimeout(() => e.target.classList.remove('dropdown'), 400)
  }

  drop(e) {
    e.target.classList.add('dropdown')
  }
}

customElements.define('external-stores', ExternalStores);